"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/inherits");

var EventTargetImpl = require("../events/EventTarget-impl").implementation;

var _require = require("../helpers/create-event-accessor"),
    setupForSimpleEventAccessors = _require.setupForSimpleEventAccessors;

var events = ["loadstart", "progress", "abort", "error", "load", "timeout", "loadend"];

var XMLHttpRequestEventTargetImpl =
/*#__PURE__*/
function (_EventTargetImpl) {
  _inherits(XMLHttpRequestEventTargetImpl, _EventTargetImpl);

  function XMLHttpRequestEventTargetImpl() {
    _classCallCheck(this, XMLHttpRequestEventTargetImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(XMLHttpRequestEventTargetImpl).apply(this, arguments));
  }

  return XMLHttpRequestEventTargetImpl;
}(EventTargetImpl);

setupForSimpleEventAccessors(XMLHttpRequestEventTargetImpl.prototype, events);
exports.implementation = XMLHttpRequestEventTargetImpl;